export const MONTH_OPTIONS = [
  { value: 'jan', text: 'January' },
  { value: 'feb', text: 'February' },
  { value: 'mar', text: 'March' },
  { value: 'apr', text: 'April' },
  { value: 'may', text: 'May' },
  { value: 'jun', text: 'June' },
  { value: 'jul', text: 'July' },
  { value: 'aug', text: 'August' },
  { value: 'sep', text: 'September' },
  { value: 'oct', text: 'October' },
  { value: 'nov', text: 'November' },
  { value: 'dec', text: 'December' },
];
